import { render, staticRenderFns } from "./ReasonTextArea.vue?vue&type=template&id=04c32789&scoped=true&"
import script from "./ReasonTextArea.vue?vue&type=script&lang=js&"
export * from "./ReasonTextArea.vue?vue&type=script&lang=js&"
import style0 from "./ReasonTextArea.vue?vue&type=style&index=0&id=04c32789&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c32789",
  null
  
)

export default component.exports